import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Response, TokenResult, ProfileViewModel } from '../../models/generated-view-models';
import { emailValidation } from '../../shared/utilities';
import { Globals } from '../../shared/globals';
import { UserProfileService } from '../../services';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public err_message: string;
    public loginForm: FormGroup;
    public isCapsLockOn: boolean = false;

    constructor(
        private authService: AuthenticationService, 
        private profileService: UserProfileService,
        private formBuilder: FormBuilder,
        private router: Router,
        private globals: Globals) { }

    ngOnInit() {
        this.buildForm();
    }

        buildForm(): void {
            this.loginForm = this.formBuilder.group({
                'email': new FormControl('', [Validators.required, emailValidation()]),
                'password': new FormControl('', [Validators.required]),
            });
        }

    public login() {
        if (!this.loginForm.get('email').value || !this.loginForm.get('password').value) {
            this.err_message = null;
        } else {
            this.authService.login(this.loginForm.value).subscribe((res: Response<TokenResult>) => {
            if (res.success) {
                localStorage.setItem('Authorization', res.result.token);
                this.profileService.getUserProfile().subscribe((res: ProfileViewModel) => {
                    this.authService.user = res;
                });
                this.router.navigate(['']);            
                this.globals.isLoogedIn = true;            
                this.err_message = null;
            } else {
                localStorage.removeItem('Authorization');
                this.globals.isLoogedIn = false;
                this.err_message = res.userFriendlyErrorMessage;
            }
            }, (err) => {
                this.err_message = err.message;
            })
        }
    }

    public capsLock = (val: boolean): void => {
        this.isCapsLockOn = val;
    }
}
